"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var MoreTableData = function MoreTableData(_ref) {
  var record = _ref.record;
  var start_date = new Date(record.Start_Date);
  return /*#__PURE__*/_react.default.createElement(_antd.Row, null, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 11,
    className: "m-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: "auto"
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    size: "small",
    bordered: true,
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Starting Date",
    text: "center",
    span: 2
  }, start_date.getFullYear(), "-", start_date.getMonth() + 1, "-", start_date.getDate())))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "CL Code",
    span: 2
  }, record.CL_Code)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "End Date",
    span: 2
  }, record.End_date ? record.End_date : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Password",
    span: 2
  }, record.RM_password ? record.RM_password : "No Data")))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 12,
    className: "m-1"
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    style: {
      height: 'auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Address",
    span: 2
  }, record.Address)))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Reasons For Leaving",
    span: 2
  }, record.Reasons_for_Leaving ? record.Reasons_for_Leaving : "Null")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Maths Response Rate",
    span: 2
  }, record.MathRR ? record.MathRR.toFixed(2) : "No Data")))), /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [3, 3],
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    span: 24
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions, {
    bordered: true,
    size: "small",
    className: "text-center"
  }, /*#__PURE__*/_react.default.createElement(_antd.Descriptions.Item, {
    labelStyle: {
      'width': 170
    },
    contentStyle: {
      'width': 500
    },
    label: "Eng Response Rate",
    span: 2
  }, record.EngRR ? record.EngRR.toFixed(2) : "No Data")))))));
};

var _default = MoreTableData;
exports.default = _default;